module.exports = __webpack_public_path__ + "static/media/bishop1.15f1ba12.jpg";